<script>
export default {
  props: ['isOpen'],
  emits: ['close'],
}
</script>

<template>
  <!-- Header links -->
  <div :class="isOpen ? 'block' : 'hidden'" class="m-0 sm:ml-4 mt-5 sm:mt-3 sm:flex p-5 sm:p-0 justify-center items-center shadow-lg sm:shadow-none">
    <router-link
      to="/projects"
      @click="$emit('close')"
      class="font-general-medium block text-left text-lg font-medium text-primary-light dark:text-ternary-light hover:text-brand-600 dark:hover:text-brand-300 sm:mx-4 mb-2 sm:py-2"
      aria-label="Portfolio"
      >Portfolio</router-link
    >
    <router-link
      to="/about"
      @click="$emit('close')"
      class="font-general-medium block text-left text-lg font-medium text-primary-light dark:text-ternary-light hover:text-brand-600 dark:hover:text-brand-300 sm:mx-4 mb-2 sm:py-2 border-t-2 pt-3 sm:pt-2 sm:border-t-0 border-primary-light dark:border-secondary-dark"
      aria-label="About"
      >About</router-link
    >
    <router-link
      to="/contact"
      @click="$emit('close')"
      class="font-general-medium block text-left text-lg font-medium text-primary-light dark:text-ternary-light hover:text-brand-600 dark:hover:text-brand-300 sm:mx-4 mb-2 sm:py-2 border-t-2 pt-3 sm:pt-2 sm:border-t-0 border-primary-light dark:border-secondary-dark"
      aria-label="Contact"
      >Contact</router-link
    >
  </div>
</template>

<style lang="scss" scoped></style>
